// Shared auth helper — loaded before all profile page scripts
window.SKAuth = (() => {
  function getApiUrl() {
    return window.__SK_API_URL || '';
  }

  // Session is gone: send to login. The login page only redirects back when a
  // valid JWT (or a working refresh) exists, so this can't loop.
  function authError() {
    window.location.replace('/pages/login');
    const err = new Error('Сесія закінчилась, увійдіть знову');
    err.code = 'AUTH';
    return err;
  }

  async function getToken() {
    const auth = window.skAuthState(window.__SK_CUSTOMER_ID)
      || await window.skAuthRefresh();
    if (!auth) throw authError();
    window.__SK_CUSTOMER_ID = auth.customerId;
    return auth.token;
  }

  function send(path, opts, token) {
    return fetch(`${getApiUrl()}${path}`, {
      ...opts,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...(opts.headers || {}),
      },
    });
  }

  async function apiFetch(path, opts = {}) {
    let res = await send(path, opts, await getToken());

    // Token rejected before its exp (e.g. JWT_SECRET rotated): refresh once and retry.
    if (res.status === 401) {
      window.skAuthDropToken(window.__SK_CUSTOMER_ID);
      res = await send(path, opts, await getToken());
      if (res.status === 401) {
        window.skAuthClear(window.__SK_CUSTOMER_ID);
        throw authError();
      }
    }

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || `Server error ${res.status}`);
    return data;
  }

  function showToast(message, type = 'success') {
    document.querySelector('.sk-toast')?.remove();
    const el = document.createElement('div');
    el.className = `sk-toast sk-toast--${type}`;
    el.textContent = message;
    document.body.appendChild(el);
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('sk-toast--visible')));
    setTimeout(() => {
      el.classList.remove('sk-toast--visible');
      el.addEventListener('transitionend', () => el.remove(), { once: true });
    }, 3000);
  }

  return { getToken, apiFetch, showToast };
})();
